var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLMTxContainer',{attrs:{"tx":_vm.tx}},[_c('AccountDetail',{attrs:{"account":_vm.created,"text":"Created","shorten":42}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }